import { toast } from "react-toastify";
import Icon from "../components/element/icon";

let isToastActive = false; // Global flag to track active toast

export const showToast = (
  title,
  description,
  type = "success",
  options = {}
) => {
  if (isToastActive) return; // Prevent spam if a toast is already active

  isToastActive = true; // Lock to prevent multiple toasts

  const content = (
    <div className="ms-2">
      <h6>{title}</h6>
      <p>{description}</p>
    </div>
  );

  const toastOptions = {
    onClose: () => {
      isToastActive = false; // Unlock when toast closes
    },
    ...options,
  };

  switch (type) {
    case "success":
      toast.success(content, {
        icon: (
          <Icon
            icon="fluent-mdl2:completed-solid"
            className="toast-icon --success"
          />
        ),
        ...toastOptions,
      });
      break;
    case "warning":
      toast.warning(content, {
        icon: (
          <Icon icon="ix:warning-filled" className="toast-icon --warning" />
        ),
        ...toastOptions,
      });
      break;
    case "error":
      toast.error(content, {
        icon: (
          <Icon icon="gridicons:cross-circle" className="toast-icon --error" />
        ),
        ...toastOptions,
      });
      break;
    default:
      toast.info(content, toastOptions);
      break;
  }
};
